import { ARMADO_URL } from '@/utils/CONST';

import ApiClient from '@/api/ApiClient';
import { generateFormData } from '@/utils/tools';

const ROUTE = 'tempworker/tempworkerdocument';
const client = new ApiClient(ROUTE);

class TempWorkerDocumentApiTempWorker {
	static add (addTempWorkerDocumentModel: IAddTempWorkerDocumentModel) {
		const formData = generateFormData(addTempWorkerDocumentModel);

		return client.post<ITempWorkerDocumentModel>('', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
	}

	static list () {
		return client.get<ITempWorkerDocumentModel[]>('');
	}

	static updateFile (updateFileTempWorkerDocumentModel: Omit<IUpdateFileTempWorkerDocumentModel, 'userId' | 'binaryFiles'>) {
		const formData = generateFormData(updateFileTempWorkerDocumentModel);

		return client.put<ITempWorkerDocumentModel>('', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
	}

	static updateMetaData (id: number, metaData: Record<string, any>) {
		return client.put<void>(`${id}/metadata`, { metaData: JSON.stringify(metaData) });
	}

	static updateExpirationDate (id: number, updateExpirationDateTempWorkerDocumentModel: Omit<IUpdateExpirationDateTempWorkerDocumentModel, 'id' | 'userId'>) {
		// updateExpirationDateTempWorkerDocumentModel.expirationDate = updateExpirationDateTempWorkerDocumentModel.expirationDate.toPost();
		return client.put<void>(`${id}/expirationdate`, updateExpirationDateTempWorkerDocumentModel);
	}

	static download (id: number) {
		client.windowOpen(`${ARMADO_URL}/app/tempworker/tempworkerdocument/${id}/file/?isDownload=true`, '_blank');
	}

	static view (id: number) {
		client.windowOpen(`${ARMADO_URL}/app/tempworker/tempworkerdocument/${id}/file`, '_blank');
	}

	/* static preview (id) {
		client.windowOpen(`${ARMADO_URL}/app/tempworker/tempworkerdocument/${id}/preview`, '_blank');
	} */

	static delete (id: number) {
		return client.delete<void>(id.toString());
	}
}

export default TempWorkerDocumentApiTempWorker;
